// extracted by mini-css-extract-plugin
export var errorsContainer = "_qw-1";
export var link = "_qw-0";